import { create } from 'zustand';

export type CrossTabSessionNoticeReason = 'user_changed' | 'signed_out';

interface CrossTabSessionNoticeState {
  isOpen: boolean;
  reason: CrossTabSessionNoticeReason | null;
  newUserEmail: string | null;
  open: (reason: CrossTabSessionNoticeReason, newUserEmail?: string | null) => void;
  close: () => void;
}

export const useCrossTabSessionNoticeStore = create<CrossTabSessionNoticeState>(
  (set) => ({
    isOpen: false,
    reason: null,
    newUserEmail: null,
    open: (reason, newUserEmail = null) =>
      set((state) => {
        if (state.isOpen && state.reason === 'user_changed') {
          return state;
        }

        return {
          isOpen: true,
          reason,
          newUserEmail: newUserEmail ?? null,
        };
      }),
    close: () => set({ isOpen: false, reason: null, newUserEmail: null }),
  })
);
